<template>
	<div class="d-flex flex-row flex-wrap">
		<template v-if="isDisplayPlaceholders">
			<div
				v-for="i in 4"
				:key="i"
				class="p-0 my-2 d-flex flex-row nowrap justify-content-start align-items-center"
				:class="itemWidthClass"
			>
				<div class="me-2">
					<PlaceholderBox
						:minHeight="`none`"
						:minWidth="`none`"
						:height="`${svgSize}px`"
						:width="`${svgSize}px`"
						:borderRadius="'50%'"
					/>
				</div>
				<PlaceholderBox
					:minHeight="'none'"
					:minWidth="'none'"
					:height="'20px'"
					:width="'100px'"
				/>
			</div>
		</template>

		<template v-else-if="criterias.length > 0">
			<div
				v-for="(criteria, criteria_i) in criterias"
				:key="criteria_i"
				class="p-0 my-2 d-flex flex-row nowrap justify-content-start align-items-center"
				:class="itemWidthClass"
			>
				<div class="me-2 d-flex align-items-center">
					<svg
						:width="svgSize"
						:height="svgSize"
						:alt="criteria.name"
						class="icon text-primary-blue me-2"
					>
						<use :xlink:href="`#___icon___${criteria.svgName}`"></use>
					</svg>
					<span class="text-start">{{ criteria.label }}</span>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue";
import { getDeepCopy } from "@/utils/utils.js";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "infoIcons",
	props: {
		prestation: {
			type: Object,
			default: () => {
				return {};
			},
		},
		svgSize: {
			type: Number,
			default: 20,
		},
		isDisplayPlaceholders: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		PlaceholderBox,
	},
	computed: {
		...mapState(["content", "screenType"]),
		...mapGetters(["infoIcons_criterias", "locale"]),
		itemWidthClass() {
			if (this.screenType === "mobile") {
				return "col-6";
			} else {
				return "";
			}
		},
		surface() {
			return this.prestation["surface"];
		},
		floorNumber() {
			return this.prestation["floorNumber"];
		},
		floorLabel() {
			return window.content.prestation_floorNumber;
		},
		// animal() {
		//     if (this.prestation.criterias.includes("52")) return true;
		// },
		maxCapacity() {
			if(!this.prestation.variants) return undefined
			const variantWithCapacity = this.prestation.variants.find((variant) => {
				return variant.maxCapacity;
			});
			if (variantWithCapacity) {
				return variantWithCapacity.maxCapacity;
			}
			return undefined;
		},
		criterias() {
			const arr = [];
			const criterias = getDeepCopy(
				this.infoIcons_criterias[this.prestation.prestationId] || []
			);
			if (this.maxCapacity) {
				// add capacity
				arr.push({
					id: null,
					svgName: "two-people",
					name: "capacity",
					label: `1-${this.maxCapacity}`,
				});
			}

			// if no criteria related to bedrooms, display 'studio'
			if (
				criterias.filter(
					(e) =>
						e.id === "338" ||
						e.id === "337" ||
						e.id === "336" ||
						e.id === "335" ||
						e.id === "334" ||
						e.id === "333" ||
						e.id === "332" ||
						e.id === "331" ||
						e.id === "330" ||
						e.id === "329" ||
						e.id === "328" ||
						e.id === "327" ||
						e.id === "326" ||
						e.id === "325" ||
						e.id === "324" ||
						e.id === "323" ||
						e.id === "322" ||
						e.id === "321" ||
						e.id === "320" ||
						e.id === "319"
				).length > 0
			) {
			} else {
				arr.push({
					id: null,
					svgName: "bed",
					name: "bed",
					label: `Studio`,
				});
			}

			criterias[1] && arr.push(criterias[1]); // add chambers

			// if (this.animal) {
			//     // add surface
			//     arr.push({
			//         id: null,
			//         svgName: "animals",
			//         name: "animal",
			//         label: `Animaux admis`,
			//     });
			// }

			if (this.surface) {
				// add surface
				arr.push({
					id: null,
					svgName: "square-space",
					name: "surface",
					label: `${this.surface}m2`,
				});
			}

			if (this.floorNumber) {
				// add surface
				arr.push({
					id: null,
					// Use the elevator svg until floor number svg is provided
					svgName: "lift",
					name: "floorNumber",
					label: `${this.floorLabel} ${this.floorNumber}`,
				});
			}

			criterias[0] && arr.push(criterias[0]); // add animals

			return arr;
		},
	},
};
</script>

<style scoped></style>
